import './AddAddressForm.scss'

import { Button, Col, Form, Input, notification, Row, Select } from 'antd'
import { AppRoutes } from 'App'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  AdreslerimDocument,
  useAdresDuzenleMutation,
  useAdresEkleMutation,
  useIlcelerQuery,
  useIllerQuery,
  useMahallelerQuery,
} from '../../gql/GeneratedGraphqlTypes'

interface Props {
  adres?: any
}

const AddAddressForm: React.FC<Props> = ({ adres }) => {
  const navigate = useNavigate()
  const isEditMode = !!adres

  const [ilValue, setIlValue] = useState<number>(adres?.il?.id ?? 0)
  const [ilceValue, setIlceValue] = useState<number>(adres?.ilce?.id ?? 0)

  const [adresEkleMutation] = useAdresEkleMutation({
    refetchQueries: [{ query: AdreslerimDocument }],
    awaitRefetchQueries: true,
  })
  const [adresDuzenleMutation] = useAdresDuzenleMutation({
    refetchQueries: [{ query: AdreslerimDocument }],
    awaitRefetchQueries: true,
  })

  const onFinish = async (values: any) => {
    try {
      if (isEditMode) {
        await adresDuzenleMutation({
          variables: {
            id: adres.id,
            adres: values.adres,
            baslik: values.baslik,
            gsm: values.gsm,
            tel: values.cep_telefonu,
            il_id: values.il_id,
            ilce_id: values.ilce_id,
            mahalle_id: values.mahalle_id,
            isim: values.isim,
            posta_kodu: values.posta_kodu,
            faks: '',
            firma: '',
            vergi_dairesi: '',
            vergi_no: '',
            kurumsal_adres_mi: false,
            adres_tipi: 'T',
          },
        })
        notification.open({
          message: 'Başarılı',
          description: 'Adres başarılı bir şekilde güncellendi.',
          type: 'success',
          placement: 'topRight',
        })
      } else {
        await adresEkleMutation({
          variables: {
            adres: values.adres,
            adres_tipi: 'T',
            baslik: values.baslik,
            faks: '',
            firma: '',
            gsm: values.gsm,
            il_id: values.il_id,
            ilce_id: values.ilce_id,
            mahalle_id: values.mahalle_id,
            isim: values.isim,
            kurumsal_adres_mi: false,
            posta_kodu: values.posta_kodu,
            tel: values.cep_telefonu,
            vergi_dairesi: '',
            vergi_no: '',
          },
        })
        notification.open({
          message: 'Başarılı',
          description: 'Adres başarılı bir şekilde eklendi.',
          type: 'success',
          placement: 'topRight',
        })
      }
      navigate(`/${AppRoutes.account.root}/${AppRoutes.account.addresses}`)
    } catch (error) {
      notification.open({
        message: 'Hata',
        description: 'Sistemsel bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
        type: 'error',
        placement: 'topRight',
      })
    }
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const { data: admData } = useIllerQuery({
    onError: (error) => console.log('erro', error),
  })

  const { data: admilceData } = useIlcelerQuery({
    onError: (error) => console.log('erro', error),
    variables: { il_id: ilValue },
  })

  const { data: admmahalleData } = useMahallelerQuery({
    onError: (error) => console.log('erro', error),
    variables: { ilce_id: ilceValue },
  })

  const initialValues = isEditMode
    ? {
        baslik: adres.baslik,
        isim: adres.isim,
        il_id: adres.il?.id,
        ilce_id: adres.ilce?.id,
        mahalle_id: adres.mahalle?.id,
        cep_telefonu: adres.gsm,
        gsm: adres.gsm,
        posta_kodu: adres.posta_kodu,
        adres: adres.adres,
      }
    : undefined

  return (
    <div className="addresses-page-add">
      <Form
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        initialValues={initialValues}
      >
        <Row gutter={24}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Başlık"
              name="baslik"
              rules={[{ required: true, warningOnly: true, type: 'string', message: 'Bu alan zorunlu!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="İsim"
              name="isim"
              rules={[{ required: true, warningOnly: true, type: 'string', message: 'Bu alan zorunlu!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="İl"
              name="il_id"
              rules={[{ required: true, warningOnly: true, type: 'number', message: 'Bu alan zorunlu!' }]}
            >
              <Select
                showSearch
                onChange={(e) => setIlValue(e)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase('tr-TR').includes(input.toLocaleLowerCase('tr-TR'))
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLocaleLowerCase('tr-TR')
                    .localeCompare((optionB?.label ?? '').toLocaleLowerCase('tr-TR'), 'tr')
                }
                options={admData?.iller.map((il) => ({ label: il?.isim, value: il?.id }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="İlçe"
              name="ilce_id"
              rules={[{ required: true, warningOnly: true, type: 'number', message: 'Bu alan zorunlu!' }]}
            >
              <Select
                showSearch
                onChange={(e) => setIlceValue(e)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase('tr-TR').includes(input.toLocaleLowerCase('tr-TR'))
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLocaleLowerCase('tr-TR')
                    .localeCompare((optionB?.label ?? '').toLocaleLowerCase('tr-TR'), 'tr')
                }
                options={admilceData?.ilceler.map((ilce) => {
                  const lower = (ilce?.isim ?? '').toLocaleLowerCase('tr-TR')
                  const label = lower.charAt(0).toLocaleUpperCase('tr-TR') + lower.slice(1)
                  return { label, value: ilce?.id }
                })}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20} wrap={true}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Mahalle"
              name="mahalle_id"
              rules={[{ required: true, warningOnly: true, type: 'number', message: 'Bu alan zorunlu!' }]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase('tr-TR').includes(input.toLocaleLowerCase('tr-TR'))
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLocaleLowerCase('tr-TR')
                    .localeCompare((optionB?.label ?? '').toLocaleLowerCase('tr-TR'), 'tr')
                }
                options={admmahalleData?.mahalleler.map((mahalle) => ({
                  label: mahalle?.isim,
                  value: mahalle?.id,
                }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Telefon"
              name="cep_telefonu"
              rules={[
                { required: true, message: 'Bu alan zorunlu!' },
                { max: 11, message: 'Telefon numarası 11 karakterden fazla olmamalıdır' },
              ]}
            >
              <Input maxLength={11} placeholder="05xx xxx xx xx" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Gsm"
              name="gsm"
              rules={[
                { required: true, message: 'Bu alan zorunlu!' },
                { max: 11, message: 'GSM 11 karakterden fazla olmamalıdır' },
              ]}
            >
              <Input maxLength={11} placeholder="05xx xxx xx xx" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Posta Kodu"
              name="posta_kodu"
              rules={[
                { required: true, warningOnly: true, type: 'string', message: 'Bu alan zorunlu!' },
                { max: 5, message: 'Posta Kodu 5 karakterden fazla olmamalıdır' },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24}>
            <Form.Item
              label="Adres"
              name="adres"
              rules={[{ required: true, warningOnly: true, type: 'string', message: 'Bu alan zorunlu!' }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <div className="add-address-button-container">
          <Button
            onClick={() => navigate(`/${AppRoutes.account.root}/${AppRoutes.account.addresses}`)}
          >
            Geri Dön
          </Button>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button className="address-save-button" type="primary" htmlType="submit">
              {isEditMode ? 'Güncelle' : 'Kaydet'}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  )
}

export default AddAddressForm
